import { queriesPayers } from "@query";
import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";

import { selectorPayerDisplayName } from "../../../shared/selectors/selectorPayerDisplayName";

type Props = {
  payerId: string;
};

export const LabelPayerName: React.FC<Props> = props => {
  const payerQuery = queriesPayers.getPayer.useQuery(
    { payerId: props.payerId },
    { retry: false }
  );

  const name = useMemo(() => {
    if (!payerQuery.data) {
      return;
    }

    return selectorPayerDisplayName(payerQuery.data);
  }, [payerQuery.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox alignItems="center" gap="XS" wrap="nowrap">
      <WSIcon color="gray600" name="user" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
